import { translate } from './translate.js';
/**
 * The CLOSED error-code set (CODE_GUIDELINES.md §16), reused as the literal
 * union for `UserAlert.code` everywhere (`@xdocs/schemas`, every WS `err`
 * envelope). This module is the localization side: mapping each code to its
 * catalog message id / resolved human string. `FORBIDDEN` is the single
 * role/ownership/ACL denial code; `CONTENT_POLICY_VIOLATION` and
 * `PROMO_INVALID` carry extra payload fields upstream (schemas package) —
 * only the base `message` is produced here.
 */
export const ERROR_CODES = [
    'VALIDATION',
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'INSUFFICIENT_CREDITS',
    'TIER_REQUIRED',
    'RATE_LIMITED',
    'CONTENT_POLICY_VIOLATION',
    'PROMO_INVALID',
    'BAD_OP',
    'INTERNAL',
];
export function isErrorCode(value) {
    return ERROR_CODES.includes(value);
}
/** `ErrorCode` → its catalog message id under the `errors` scope. */
export function errorCodeToMessageId(code) {
    return `errors:code.${code}`;
}
/**
 * `toUserAlert(code, locale)` — resolves a closed `ErrorCode` to a localized,
 * safe-to-toast `{ code, message }` (CODE_GUIDELINES §3.2/§16). This is the
 * error-CODE variant; `@xdocs/schemas`' `toUserAlert(ZodError)` (§3.2) is the
 * companion validation-issue variant — both produce the same `UserAlert`
 * shape and both resolve their `message` through this package's catalog so
 * the wording is identical wherever an alert is built (server `err` envelope,
 * client toast, REST error body).
 */
export function toUserAlert(code, locale, vars) {
    return { code, message: translate(locale, errorCodeToMessageId(code), vars) };
}
